import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import session from 'containers/App/session';
import * as actions from '../../../actions';
import * as selectors from '../../../selectors';

import { Modal, Alert } from 'antd';
import Button from 'components/forms/Button';
import SavesSelectionTable from './SavesSelectionTable';

const SavesManagementModal = ({ visible, formType, onClose }) => {
    if (!visible) return null;
    const dispatch = useDispatch();
    const [selectedSaveID, setSelectedSaveID] = useState(null);
    const propertyId = useSelector(session.selectors.selectSelectedPropertyId);
    const userUuid = useSelector(session.selectors.selectUserDetails).uuid;
    const savesFetchingState = useSelector((state) => selectors.selectFetchedSavesState(state, formType));
    const saveLoadingState = useSelector((state) => selectors.selectLoadedSaveState(state, formType));
    const fetchSaves = () => {
        dispatch(actions.fetchSaves(formType, propertyId, userUuid));
    };

    useEffect(() => {
        fetchSaves();
    }, []);

    const resetAndCloseModal = () => {
        dispatch(actions.resetFetchedSavesState());
        dispatch(actions.resetLoadedSaveState());
        onClose();
    };

    const loadSelectedSave = () => {
        dispatch(actions.loadSave(selectedSaveID));
    };

    /**
     * This handles showing loading state and errors in the modal and only closing it following a successful loading of the save
     * by keeping track of the previous state
     */
    const [prevState, setPrevState] = useState(saveLoadingState);
    useEffect(() => {
        if (saveLoadingState.fetching === false && prevState.fetching && !saveLoadingState.error) {
            resetAndCloseModal();
        }
        setPrevState(saveLoadingState);
    }, [saveLoadingState, prevState]);

    return (
        <Modal
            centered
            open
            title="Load a save"
            footer={[
                <Button key="cancelBtn" onClick={resetAndCloseModal} disabled={saveLoadingState.fetching}>
                    Close
                </Button>,
                <Button
                    key="confirmBtn"
                    type="primary"
                    onClick={loadSelectedSave}
                    loading={saveLoadingState.fetching}
                    disabled={selectedSaveID == null}
                >
                    Open selected save
                </Button>,
            ]}
            maskClosable={false}
            closable={false}
            width={1000}
        >
            {savesFetchingState.error && (
                <Alert
                    style={{ marginBottom: '1.5em' }}
                    type="error"
                    message="Something went wrong"
                    description={
                        <>
                            Sorry, we couldn't retrieve your saves. Please try again later.
                            <Button
                                name="retryFetchButton"
                                onClick={fetchSaves}
                                size="small"
                                style={{ marginLeft: '0.8em' }}
                            >
                                Retry
                            </Button>
                        </>
                    }
                    showIcon
                />
            )}
            <SavesSelectionTable
                {...savesFetchingState}
                selectedSaveID={selectedSaveID}
                onSelectSave={setSelectedSaveID}
            />
            {saveLoadingState.error && (
                <Alert
                    style={{ marginTop: '1.5em' }}
                    type="error"
                    message="Something went wrong"
                    description={
                        <>
                            Sorry, we couldn't retrieve your selected save's info. Please try again later.
                            <Button
                                name="retryFetchButton"
                                onClick={loadSelectedSave}
                                size="small"
                                style={{ marginLeft: '0.8em' }}
                            >
                                Retry
                            </Button>
                        </>
                    }
                    showIcon
                />
            )}
        </Modal>
    );
};

export default SavesManagementModal;
